import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../../lib/react-query'
import { attackSurfaceApi } from '../../services/api'
import { useAuthStore } from '../../store/authStore'

/**
 * Hook for fetching attack surface overview data
 * Includes all metrics for domains, IPs, ports, SSL, etc.
 */
export function useAttackSurface(params?: string) {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.attackSurface.overview(orgId, params || ''),
    queryFn: () => attackSurfaceApi.getData(params),
    enabled: !!orgId,
  })
}
